export default "__VITE_ASSET__DsMfnx7Z__"